import axios from "axios";

export default class AvailableCabinService {
  static getAvailableCabins(cruise_id, reservation_id, booking_id) {
    var url =
      "cruise/" +
      cruise_id +
      "/reservation/" +
      reservation_id +
      "/booking/" +
      booking_id +
      "/selectCabins";
    return axios.get(url);
  }

  static updateTwoCabins(payload) {
    var url = "bookings/switchTwoCabins";
    return axios.put(url, payload);
  }
  static updateOneCabin(payload) {
    var url = "bookings/switchOneCabin";
    return axios.put(url, payload);
  }
}
